import React from "react";

import Slider from "react-slider";
import { motion } from "framer-motion";
import { Color } from "../../logic/enums.ts";
import { getTailwindBackgroundColor } from "../../logic/logic.js";

const RaindropSlider = ({
  value,
  onChange,
  className = "",
  min = 10,
  max = 100,
  color = Color.Raindrop,

  step = 1.0,
  marks = [],
  onBeforeChange = null,
  onAfterChange = null,
  locked = false,
}) => {
  return (
    <Slider
      value={value}
      disabled={locked}
      min={min}
      max={max}
      step={step}
      marks={marks}
      onChange={onChange}
      className={"py-3 my-2 h-10 w-full " + className}
      onAfterChange={onAfterChange}
      onBeforeChange={onBeforeChange}
      renderThumb={(props, state) => {
        let backgroundColor = getTailwindBackgroundColor(color);
        let cursor = "cursor-pointer";

        if (locked) {
          backgroundColor = "bg-color-raindrop-minor";
          cursor = "cursor-default";
        }

        return (
          <motion.div
            {...props}
            className={`flex flex-col items-center w-8 h-8 -mt-2 outline-none justify-center ${cursor} `}
          >
            <div
              className={`p-4 rounded-full shadow-lg  ${cursor} ${backgroundColor} border-4 border-white `}
            />
            <div className="h-3 w-4 bg-white opacity-30 aspect-square absolute translate-x-0 translate-y-2 rounded-full" />
          </motion.div>
        );
      }}
      renderTrack={(props, state) => {
        const isLeftSide = state.index === 0;

        let backgroundColor =
          "dark:bg-color-dark-background-tertiary bg-color-background-tertiary";
        let height = "h-0.5";
        let marginTop = "mt-2";
        let opacity = "opacity-100";
        let cursor = "cursor-pointer";
        let border = "";

        if (isLeftSide) {
          // backgroundColor = "bg-color-raindrop-primary";
          backgroundColor = getTailwindBackgroundColor(color);
          height = "h-4";
          marginTop = "mt-0";
          opacity = "opacity-50";
        }

        if (locked) {
          backgroundColor = "bg-color-raindrop-minor";
          cursor = "cursor-default";
        }

        return (
          <motion.div
            {...props}
            className={`flex flex-row rounded-full items-center justify-center text-xs ${cursor} ${backgroundColor} ${height} ${marginTop} ${opacity} ${border} `}
            onTapStart={() => {}}
          />
        );
      }}
    />
  );
};

export default RaindropSlider;
